var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9338",
    "data-name": "Group 9338",
    transform: "translate(-5073 -7031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "description_black_24dp",
    transform: "translate(5073 7031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    d: "M0,0H22V22H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    d: "M7.667,14.833H15v1.833H7.667Zm0-3.667H15V13H7.667ZM13.167,2H5.833A1.839,1.839,0,0,0,4,3.833V18.5a1.831,1.831,0,0,0,1.824,1.833H16.833A1.839,1.839,0,0,0,18.667,18.5V7.5Zm3.667,16.5h-11V3.833H12.25V8.417h4.583Z",
    transform: "translate(-0.333 -0.167)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_4844",
    "data-name": "Path 4844",
    transform: "translate(15.942 10.35) rotate(90)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.167585849761963 1.692300796508789 L 0.9766708016395569 1.692300796508789 L 1.576804041862488 0.859596848487854 L 2.167585849761963 1.692300796508789 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.579998016357422 7.152557373046875e-07 L 3.135377883911133 2.192300796508789 L -1.9073486328125e-06 2.192300796508789 L 1.579998016357422 7.152557373046875e-07 Z",
    stroke: "none",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_4845",
    "data-name": "Path 4845",
    transform: "translate(6.076 17.191) rotate(-90)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.232915639877319 1.515566229820251 L 1.09773051738739 1.493640422821045 L 1.718327760696411 0.7984265089035034 L 2.232915639877319 1.515566229820251 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.760823011398315 4.76837158203125e-06 L 3.220862865447998 2.034744739532471 L 3.099441528320312e-06 1.972534775733948 L 1.760823011398315 4.76837158203125e-06 Z",
    stroke: "none",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.724b5287c084c79118552d8e1a861b25.svg";
export { ForwardRef as ReactComponent };